// GA4 key events used as Google Ads conversions.
//
// These fire on the GA4 property (G-48ENESP49X) which is configured in
// src/components/Header/index.js. To count them in Google Ads:
//   GA4 admin -> Events -> mark `generate_lead` and `book_call` as key events,
//   then Google Ads -> Goals -> Import -> Google Analytics 4.
//
// Consent Mode defaults to denied in Header/index.js and is granted by the
// Consent banner, so these events respect the visitor's choice automatically.

const GA4_MEASUREMENT_ID = 'G-48ENESP49X'

// Indicative lead values for value-based bidding in Google Ads.
// Set to 0 if you'd rather count leads without a monetary value.
const SYLLABUS_LEAD_VALUE = 20.0
const BOOK_CALL_LEAD_VALUE = 50.0
const CURRENCY = 'EUR'

// gtag is defined by react-ga4 / Header. Fall back to a raw dataLayer push so
// an event is never silently dropped if the tag hasn't finished loading.
const sendEvent = (eventName, params) => {
	if (typeof window === 'undefined') return

	const payload = { send_to: GA4_MEASUREMENT_ID, ...params }

	if (typeof window.gtag === 'function') {
		window.gtag('event', eventName, payload)
		return
	}

	window.dataLayer = window.dataLayer || []
	window.dataLayer.push(['event', eventName, payload])
}

const currentPath = () =>
	typeof window !== 'undefined' ? window.location.pathname : ''

const sendOpenAiEvent = (eventName, data) => {
	if (typeof window === 'undefined' || typeof window.oaiq !== 'function') return

	window.oaiq('measure', eventName, data)
}

// Fired when a visitor successfully requests a course syllabus.
export const trackSyllabusRequest = ({ course, courseLink } = {}) => {
	sendEvent('generate_lead', {
		value: SYLLABUS_LEAD_VALUE,
		currency: CURRENCY,
		lead_source: 'syllabus_download',
		course: course || 'unspecified',
		course_link: courseLink || '',
		page_path: currentPath(),
	})
}

// Fired when a visitor clicks through to the zcal booking page.
export const trackBookCallClick = () => {
	sendEvent('book_call', {
		value: BOOK_CALL_LEAD_VALUE,
		currency: CURRENCY,
		lead_source: 'book_a_call',
		page_path: currentPath(),
	})

	sendOpenAiEvent('appointment_scheduled', {
		type: 'customer_action',
	})
}
